var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJumpToLeftArrowcol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,27a2.6,2.6,0,0,1-1.27-.34L7.26,22.41A2.5,2.5,0,0,1,6,20.25V11.74A2.51,2.51,0,0,1,7.25,9.59l7.48-4.26A2.66,2.66,0,0,1,16,5a2.55,2.55,0,0,1,1.28.34l7.47,4.25A2.5,2.5,0,0,1,26,11.75v8.51a2.51,2.51,0,0,1-1.25,2.15l-7.48,4.26A2.7,2.7,0,0,1,16,27Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a1.64,1.64,0,0,1,.77.2l7.48,4.27A1.47,1.47,0,0,1,25,11.74v8.5a1.48,1.48,0,0,1-.76,1.3l-7.46,4.25A1.55,1.55,0,0,1,16,26a1.65,1.65,0,0,1-.78-.2L7.74,21.53A1.47,1.47,0,0,1,7,20.26v-8.5a1.48,1.48,0,0,1,.76-1.3l7.46-4.25A1.55,1.55,0,0,1,16,6h0m0-2h0a3.54,3.54,0,0,0-1.76.47L6.77,8.72a3.5,3.5,0,0,0-1.77,3v8.52a3.5,3.5,0,0,0,1.77,3l7.46,4.25a3.57,3.57,0,0,0,3.54,0l7.46-4.25a3.5,3.5,0,0,0,1.77-3V11.74a3.5,3.5,0,0,0-1.77-3L17.77,4.47A3.54,3.54,0,0,0,16,4Z",
    fill: "#04A6FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.36,21l1.14-1.17L16.79,16l3.71-3.83L19.36,11,14.5,16Z",
    fill: "#04A6FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.36,21l1.14-1.17L11.79,16l3.71-3.83L14.36,11,9.5,16Z",
    fill: "#04A6FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpToLeftArrowcol);
export default __webpack_public_path__ + "static/media/Jump To Left Arrowcol.9570678d88c8e163d926b8a9bb03c27c.svg";
export { ForwardRef as ReactComponent };